<template>
	<div class="file-uploader">
		<input
			ref="control"
			:accept="accept"
			type="file"
			class="upload_control"
			@change="selectFile"
		/>
		<div class="action" @click="openWindow">
			<slot name="action" :loading="loading" :file="file" />
		</div>
	</div>
</template>

<script>
import api from '../api';

export default {
	name: 'HiddenFileUploader',
	props: {
		accept: {
			type: String,
			default: ''
		},
		projectId: {
			type: [String, Number]
		},
		fingerprint: {
			type: Object
		},
		questionId: {
			default: null
		}
	},
	data() {
		return {
			file: null,
			loading: false
		};
	},
	methods: {
		openWindow() {
			const control = this.$refs.control;
			if (!control) return;
			control.click();
		},
		emitUploadStatus(value) {
			this.loading = value === 'start';
			this.$emit('loading', value);
		},
		success(attachments) {
			const [file] = attachments;
			if (!file) return;
			this.$emit('success', file);
		},
		failed(failed) {
			const [{ message }] = failed;
			this.$emit('failed', message);
		},
		async getFormData() {
			const data = new FormData();
			const fingerprint = await this.fingerprint.getFingerPrint();
			data.append('_method', 'post');
			data.append('files[]', this.file);
			data.append('project_id', this.projectId);
			data.append('fingerprint', fingerprint);
			if (this.questionId) {
				data.append('question_id', this.questionId);
			}
			return data;
		},
		async uploadFile() {
			this.emitUploadStatus('start');
			const data = await this.getFormData();
			const response = await api.uploadFile(data);
			if (response.success) {
				this.success(response.attachments);
			} else {
				this.failed(response.failed);
			}
			this.emitUploadStatus('finish');
		},
		selectFile(event) {
			const [file] = event.target.files;
			this.$emit('select-file', file);
			this.file = file;
			console.log(file);
			this.uploadFile();
		}
	}
};
</script>

<style scoped lang="scss">
.file-uploader {
	position: relative;
}
.upload_control {
	display: none;
}
</style>
